import Storage from './storageHelper';
import {setCookie, checkCookie, getCookie} from '../../utils/cookie';
import Globals from '../../constants/appConstants';

const getLeadAddressFromCookie = () => { 
    let leadAddressCookie = checkCookie("leadAddressCookie")?getCookie("leadAddressCookie").trim():false;
    try {
      leadAddressCookie = JSON.parse(leadAddressCookie);
    } catch(err){
      leadAddressCookie = false;
    }
    
    if(!leadAddressCookie) return "";
    
    const isLogin = Storage.customerSummary() ? true : false;
    
    let address = "";
    if(isLogin){
      address = leadAddressCookie.registered?leadAddressCookie.registered:"";
    } else {
      address = leadAddressCookie.guest?leadAddressCookie.guest:"";
    }
    
    return address;
}

const setLeadAddressInCookie = (val = "") => {
    let leadAddressCookie = checkCookie("leadAddressCookie") ? getCookie("leadAddressCookie").trim() : false;
    
    try {
      leadAddressCookie = JSON.parse(leadAddressCookie);
    } catch(err){
      leadAddressCookie = false;
    }
    const isLogin = localStorage.getItem('cusToken') !== null ? true : false;
    
    let leadAddrCookieObj = {};
    if(isLogin){
      if(leadAddressCookie){
        leadAddrCookieObj = {
          ...leadAddressCookie,
          "registered": val
        }
      } else {
        leadAddrCookieObj = {
          "guest":"",
          "registered":val
        };
      }
    } else {
      if(leadAddressCookie){
        leadAddrCookieObj = {
          ...leadAddressCookie,
          "guest": val
        }
      } else {
        leadAddrCookieObj = {
          "guest": val,
          "registered":""
        };
      }
    }

    /* store address in cookie */
    const cookieExpiry = typeof Globals.leaddata !== "undefined" && Globals.leaddata.leadAddressCookieExpiry ? parseInt(Globals.leaddata.leadAddressCookieExpiry) : 365;
    const leadAddrCookieObjStr = JSON.stringify(leadAddrCookieObj);
    
    setCookie("leadAddressCookie", leadAddrCookieObjStr, cookieExpiry*24*60);
    return true;
}

export {
  getLeadAddressFromCookie,
  setLeadAddressInCookie
};